import React, { Component, PropTypes } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { connectReduxForm } from 'redux-form';
import { validateClass } from './validateClass';
import { defaultLanguage, i18n, languages } from 'helpers/i18n'
import lodash from 'lodash';

@connectReduxForm({
  form: 'addEditClass',
  fields: [
    'alert',
    'program',
    'language',
    'grade',
    'divisionName',
    'numberOfStudents'
  ],
  validate: validateClass
})
export default class AddEditClassModal extends Component {

  static propTypes = {
    programs: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    fields: PropTypes.shape({
      alert: PropTypes.object.isRequired,
      program: PropTypes.object.isRequired,
      language: PropTypes.object.isRequired,
      grade: PropTypes.object.isRequired,
      divisionName: PropTypes.object.isRequired,
      numberOfStudents: PropTypes.object.isRequired
    }).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    edit: PropTypes.bool,
    text: PropTypes.string,
    title: PropTypes.string
  };

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.i18n = i18n(props.fields.language.value || defaultLanguage);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fields.language.value !== this.props.fields.language.value) {
      this.i18n = i18n(nextProps.fields.language.value || defaultLanguage);
    }
  }

  getSelectedProgramDescription() {
    const {
      program: {value: selectedProgramId}
    } = this.props.fields;
    const _ = this.i18n;
    if (!selectedProgramId) {
      return '';
    }
    const program = lodash.find(this.props.programs, prog => prog.id === selectedProgramId);
    if (!program) {
      return '';
    }
    return _(program.shortDescription);
  }

  getSelectedProgramTitle() {
    const {
      program: {value: selectedProgramId}
    } = this.props.fields;
    const _ = this.i18n;
    if (!selectedProgramId) {
      return '';
    }
    const program = lodash.find(this.props.programs, prog => prog.id === selectedProgramId);
    if (!program) {
      return '';
    }
    return _(program.title);
  }

  getSelectedProgramLanguages() {
    const selectedProgramId = this.props.fields.program.value;
    if (!selectedProgramId) {
      return [];
    }
    const program = lodash.find(this.props.programs, prog => prog.id === selectedProgramId);
    if (!program) {
      return [];
    }
    return (program.languages || [defaultLanguage])
  }

  render () {
    const {
      showModal,
      closeModal,
      programs,
      fields: {
        alert,
        program,
        language,
        grade,
        divisionName,
        numberOfStudents
      },
      handleSubmit,
      edit,
      title
    } = this.props;
    const _ = this.i18n;

    return (
      <Modal show={showModal} onHide={closeModal} dialogClassName="add-edit-class-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            {title ?
              title :
              edit
                ? _`Edit class details`
                : _`Add a class`
            }
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>

            <div className="row">
              <div className="col-sm-8 col-md-12">

                <h4>{this.props.text}</h4>

                {/* Alert */}
                {alert.error &&
                <div className="form-group">
                  <div className="alert alert-danger">
                    {alert.error}
                  </div>
                </div>
                }

                {/* Program */}
                {edit
                    ?
                    <div className="form-group">
                      <label className="control-label">
                        {_('Program')}
                      </label>
                      <input type="hidden" {...program} />
                      <div>{this.getSelectedProgramTitle()}</div>
                    </div>
                    :
                    <div className={'form-group ' +
                      (program.error && program.touched &&
                      'has-error')}>
                      <label htmlFor="selectProgram"
                           className="control-label">
                        {_('Pick a program')} (<a className="learnAboutPrograms" href={`/programs`}>{_('Learn about programs')}</a>)
                      </label>
                      <select id="selectProgram"
                              className="form-control"
                              {...program}>
                        <option value="">-- {_('Choose a program')} --</option>
                        {programs.map(prog => {
                          return (
                              <option key={prog.id} value={prog.id}>{_(prog.title)}</option>
                          );
                        })}
                      </select>
                      {program.error && program.touched &&
                      <div className="text-danger">{_(program.error)}</div>
                      }
                      <h4>{this.getSelectedProgramDescription()}</h4>
                    </div>
                }

                {/* Language */}
                <div className={'form-group ' +
                                (language.error && language.touched &&
                                'has-error')}>
                  <label htmlFor="selectLanguage">
                    {_('Language')}
                  </label>
                  <select id="selectLanguage"
                          className="form-control"
                          {...language}>
                    {this.getSelectedProgramLanguages().map(lng => {
                      return (
                        <option key={lng} value={lng}>{languages[lng]}</option>
                      )
                    })}
                  </select>
                  {language.error && language.touched &&
                  <div className="text-danger">{_(language.error)}</div>
                  }
                </div>

                {/* Grade */}
                <div className={'form-group ' +
                                (grade.error && grade.touched &&
                                 'has-error')}>
                  <label htmlFor="txtGrade"
                         className="control-label">
                    {_('Grade')}
                  </label>
                  <input id="txtGrade"
                         type="text"
                         className="form-control"
                         placeholder=""
                         spellCheck="false"
                         autoComplete="off"
                         maxLength={80}
                         {...grade} />
                  {grade.error && grade.touched &&
                   <div className="text-danger">{_(grade.error)}</div>
                  }
                </div>

                {/* Division Name */}
                <div className={'form-group ' +
                                (divisionName.error &&
                                 divisionName.touched &&
                                 'has-error')}>
                  <label htmlFor="txtDivisionName"
                         className="control-label">
                    {_('Class/Division Name or #')}
                  </label>
                  <input id="txtDivisionName"
                         type="text"
                         className="form-control"
                         placeholder=""
                         spellCheck="false"
                         autoComplete="off"
                         maxLength={80}
                         {...divisionName} />
                  {divisionName.error && divisionName.touched &&
                   <div className="text-danger">{_(divisionName.error)}</div>
                  }
                </div>

                {/* Number of Students */}
                <div className={'form-group ' +
                                (numberOfStudents.error &&
                                 numberOfStudents.touched &&
                                 'has-error')}>
                  <label htmlFor="txtNumberOfStudents"
                         className="control-label">
                    {_('# of Students')}
                  </label>
                  <input id="txtNumberOfStudents"
                         type="number"
                         className="form-control"
                         placeholder=""
                         min="0"
                         spellCheck="false"
                         max={Number.MAX_SAFE_INTEGER}
                         {...numberOfStudents} />
                  {numberOfStudents.error && numberOfStudents.touched &&
                   <div className="text-danger">{_(numberOfStudents.error)}</div>
                  }
                  {
                    numberOfStudents.valid && numberOfStudents.value > 40 &&
                      <div style={{color: "#FF8300 !important"}}>
                        <p><em>{_('Top Tip!')}</em> {_('The program is designed to be used with one classroom at a time.')}</p>
                        <p><em>{_('Want to use it in multiple classrooms?')}</em> {_('Add additional classes from the Programs page so that your progress and team points are saved separately for each class!')}</p>
                      </div>
                  }
                </div>

              </div>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <Row>
            <Col xs={12} sm={6}>
              <div style={{textAlign: "left"}}>
                {!edit && _("By adding your class, you agree to receive occasional emails with tips from a real human to help you get started!")}
              </div>
            </Col>
            <Col xs={12} sm={6}>
              <button type="submit" className="btn btn-lg btn-primary">
              {edit
                  ? _`Save`
                  : _`Add Class`
              }
              </button>
            </Col>
            </Row>
          </Modal.Footer>

        </form>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/dashboard/addEditClassModal.jsx